import React from "react";
import DashboardCard from "../DashboardCard";
import ImageLoader from "../ImageLoader";
import { Link } from "react-router-dom";

const GettingStarted = () => {
  return (
    <>
      <section>
        <DashboardCard className="pt-0 pb-8 px-6 mt-24">
          <h2 className="text-3xl font-bold mb-4">
            Case Study: Email Deep Research Agent
          </h2>
          <div className="prose max-w-none overflow-hidden">
            <div className="flex flex-col md:flex-row items-start gap-4">
              <div className="w-full md:w-1/2">
                <p className="mb-4">
                  We trained an email agent using our{" "}
                  <a href="https://github.com/OpenPipe/ART">
                    agent reinforcement trainer
                  </a>{" "}
                  (ART) that finds and answers deep-research-type questions
                  within your inbox. We achieved SOTA with a small Qwen 2.5 14B
                  model, which also comes with lower latency, lower cost, and
                  the ability to deploy on-prem.
                </p>
                <p>
                  Learn more about how we did this in our{" "}
                  <Link to="/blog/art-e-mail-agent">blog post</Link>{" "}
                  highlighting ART, our industry-leading RL framework.
                </p>
              </div>
              <div className="w-full md:w-1/2">
                <div className="flex flex-col items-center">
                  <h6 className="text-lg font-semibold text-center">
                    Email Agent Success Rate
                  </h6>
                  <div className="w-full flex justify-center image-container">
                    <ImageLoader
                      src="/hero-images/ART-hero.svg"
                      alt="Email Agent Success Rate"
                      className="w-auto max-w-[150px]"
                      priority={true}
                      variant="hero"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </DashboardCard>
      </section>

      <section>
        <DashboardCard className="pt-0 pb-8 px-6 font-mono">
          <h2 className="text-3xl font-bold mb-4">What We Do</h2>
          <div className="prose max-w-none overflow-hidden">
            <p className="mb-6">
              OpenPipe's post-training platform makes it easy to get
              product-defining results through SFT and reinforcement learning.
              We pair RL experts with your team to quickly identify the
              highest‑impact use cases to meet your business goals. Within a few
              weeks, you'll see side‑by‑side evals that quantify how RL‑trained
              agents outperform standard implementations on your own metrics of
              quality, compliance, and cost.
            </p>
            <p>
              Our key technology is the open-source{" "}
              <a href="https://github.com/OpenPipe/ART">
                agent reinforcement trainer
              </a>{" "}
              (ART), our industry-leading RL framework.
            </p>
          </div>
        </DashboardCard>
      </section>
    </>
  );
};

export default GettingStarted;
